import Vue from 'vue'
import { ApolloClient, HttpLink, InMemoryCache, split } from "@apollo/client/core";
import { getMainDefinition } from '@apollo/client/utilities'
import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { onError } from '@apollo/client/link/error'
import { logErrorMessages } from '@vue/apollo-util'
import { createClient } from 'graphql-ws'
import VueApollo from 'vue-apollo'

const customFetch = (uri, options) => {
    const token = Vue.prototype.$keycloak.token
    options.headers.Authorization = `Bearer ${token}`;
    return fetch(uri, options);
}

const linkAdmin = new HttpLink({
    uri: `${process.env.VUE_APP_CT_URL_V1}/graphql/admin`,
    // credentials: 'include',
    fetch: customFetch
});

const linkOpen = new HttpLink({
    uri: `${process.env.VUE_APP_CT_URL_V1}/graphql/open`
});

const uploadLink = split(
    operation => operation.getContext().clientName === 'open',
    linkOpen,
    linkAdmin
)

const wsLink = new GraphQLWsLink(createClient({
    url: `${process.env.VUE_APP_CT_WS_V1}/subscriptions/admin`,
    connectionParams: function () {
        return { token: Vue.prototype.$keycloak.token };
    }
}))

const errorLink = onError(error => {
    // if (process.env.NODE_ENV !== 'production') {
    logErrorMessages(error)
    // }
})

const splitLink = split(
    ({ query }) => {
        const definition = getMainDefinition(query)
        return (
            definition.kind === 'OperationDefinition' &&
            definition.operation === 'subscription'
        )
    },
    wsLink,
    uploadLink
)

const apolloClient = new ApolloClient({
    link: errorLink.concat(splitLink),
    cache: new InMemoryCache()
});

Vue.use(VueApollo)
const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
        $query: {
            fetchPolicy: 'cache-and-network'
        }
    }
})
Vue.prototype.$apolloClient = apolloClient

export default apolloProvider 